import PeopleImg from "../../assets/images/people.jpg";
// import AssetImg from "../../assets/images/manage assets.jpg";
import DocumentImg from "../../assets/images/documents.jpg";
// import RecruitImg from "../../assets/images/recruitment.jpg";
import RequestImg from "../../assets/images/requests.jpg";
import SeperationImg from "../../assets/images/separation.jpg";
import AttendanceImg from "../../assets/images/attendance.jpg";
import MediImg from "../../assets/images/medi assist.jpg";
import HappayImg from "../../assets/images/happay.jpg";
import QuestImg from "../../assets/images/quest2travel.jpg";
import ascentImg from "../../assets/images/ascent payroll.jpg";
import PeopleIcon from "../../assets/icons/groups.svg";
import Helpdesk from "../../assets/images/helpdesk.jpg";
import LearnMoreImg from "../../assets/images/learn_module_tile.png";
// import AssetIcon from "../../assets/icons/devices.svg";
import DocumentIcon from "../../assets/icons/folder_copy.svg";
// import RecruitIcon from "../../assets/icons/person_search.svg";
import RequestIcon from "../../assets/icons/chat_paste_go.svg";
import AttendanceIcon from "../../assets/icons/free_cancellation (1).svg";
import SeperationIcon from "../../assets/icons/person_cancel (1).svg";
import ascentIcon from "../../assets/icons/ascenthr 1.svg";
import helpdeskIcon from "../../assets/icons/helpdesk_icon.svg";
import brandBayIcon from "../../assets/icons/brandBayIcon2.svg";
import MediIcon from "../../assets/icons/Frame.svg";
import HappayIcon from "../../assets/icons/Group (1).svg";
import QuestIcon from "../../assets/icons/myBiz-Quest2Travel-logo1 1.svg";
import LearnIcon from "../../assets/icons/learn_ico.svg";
import ArrowIcon from "../../assets/icons/arrow_outward.svg";
import brandBay from "../../assets/images/brandbay.jpg";
import PeopleNavIcon from "../../assets/icons/people_new.svg";
import DocumentNavIcon from "../../assets/icons/documents.svg";
import RequestNavIcon from "../../assets/icons/request_new.svg";
import AttendanceNavIcon from "../../assets/icons/attendance_new.svg";
import SeperationNavIcon from "../../assets/icons/dynamic_project_identifier.svg";
import AscentNavIcon from "../../assets/icons/ascenthr 1.svg";
import MediNavIcon from "../../assets/icons/Frame.svg";
import HappayNavIcon from "../../assets/icons/Group (1).svg";
import QuestNavIcon from "../../assets/icons/myBiz-Quest2Travel-logo1 1.svg";
import LearnNavIcon from "../../assets/icons/learn_side.svg";
import HelpdeskNavIcon from "../../assets/icons/helpdesk_sidebar_icon.svg";
import BrandBayIcon from "../../assets/icons/brandBayIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/AuthSlice";
import { getUserDetails } from "../../store/AuthSlice/thunk";
import { SSOAuthorization } from "more-sso-sdk";
import AllModulesImg from "../../assets/icons/grid_view.svg";
import TaskBoxImg from "../../assets/icons/approval.svg";
import InitialsCircle from "../../components/InitialsCircle";
import "./AllModules.css";

const AllModules = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const taskLength = useSelector((state) => state.taskbox.totalTaskLength);
  const fullName = useSelector(
    (state) => state.auth?.loginResponse?.display_name,
  );
  const employeeID = useSelector((state) => state.auth.employeeID);
  const roleType = useSelector(
    (state) => state.auth?.loginResponse?.body?.role_type,
  );

  const profileName = fullName?.split(" ")?.[0] || fullName || "there";

  const goToProfile = () => {
    dispatch(authActions.setProfileTabSelected("overview"));
    if (employeeID && roleType) {
      dispatch(
        getUserDetails({
          employee_id: employeeID,
          user_type: roleType,
        }),
      );
    }
    navigate("../profile");
  };

  const logoutHandler = () => {
    dispatch(authActions.logout());
    if (process.env.NODE_ENV === "production") {
      const url =
        process.env.REACT_APP_ENV === "UAT"
          ? "https://people-uat.more.in/"
          : "https://people.more.in/";
      SSOAuthorization.logout(url).catch((error) => {
        console.error("Logout failed", error);
      });
    }
  };

  const navCards = [
    { icon: AllModulesImg, title: "All Modules", path: "../all" },
    {
      icon: TaskBoxImg,
      title: "Taskbox",
      path: "../taskbox",
      notifyCount: true,
      count: taskLength || 0,
    },
    { icon: PeopleNavIcon, title: "People", path: "../people" },
    { icon: DocumentNavIcon, title: "Documents", path: "../documents" },
    { icon: RequestNavIcon, title: "Requests", path: "../requests" },
    { icon: SeperationNavIcon, title: "Separation", path: "../separation" },
    {
      icon: AttendanceNavIcon,
      title: "Attendance & Leave",
      path: "../attendance",
    },
    {
      icon: MediNavIcon,
      title: "Medi Assist",
      url: "https://portal.medibuddy.in/Home.aspx",
      redirect: true,
    },
    {
      icon: HappayNavIcon,
      title: "Happay",
      url: "https://expense.happay.in",
      redirect: true,
    },
    {
      icon: QuestNavIcon,
      title: "Quest2Travel",
      url: "https://www.quest2travel.in/frontend/emplogin",
      redirect: true,
    },
    {
      icon: AscentNavIcon,
      title: "stoHRM",
      url: "https://www.stohrm.com/stohrmwebapp/index.php/mrpl/admin",
      redirect: true,
    },
    {
      icon: HelpdeskNavIcon,
      title: "Helpdesk",
      url: "https://sites.google.com/moreretail.in/hrhelpdesk/home",
      redirect: true,
    },
    {
      icon: BrandBayIcon,
      title: "Brandbay",
      url: "https://brandbay.more.in/",
      redirect: true,
    },
    {
      icon: LearnNavIcon,
      title: "Learn",
      url: "https://learn.more.in/",
      redirect: true,
    },
  ];

  const ModuleTile = ({
    bgImage,
    bgIcon,
    title,
    subtitle,
    redirect = false,
    path,
    url,
  }) => (
    <div
      className="flex flex-col module-tile"
      onClick={() => {
        if (path) {
          navigate(path);
          dispatch(authActions.setSelectedPage(path.replace("../", "")));
        }
        if (url) {
          window.open(url, "_blank");
        }
      }}
    >
      <img className="tile-img" src={bgImage} alt="" />
      <div
        className={
          redirect ? "bg-image-ico-wrapper-redirect" : "bg-image-ico-wrapper"
        }
      >
        <img src={bgIcon} className="bg-image-ico" alt="" />
      </div>
      <div className="flex items-center justify-between w-full">
        <div className="tile-title">{title}</div>
        {redirect && <img src={ArrowIcon} className="arr-icon" alt="" />}
      </div>
      <div className="tile-subtitle">{subtitle}</div>
    </div>
  );
  return (
    <div className="flex flex-col all-modules">
      <div className="all-modules-top">
        <div className="all-modules-profile" onClick={goToProfile}>
          {/* <div className="all-modules-avatar"> */}
          <InitialsCircle fullName={fullName} size={40} type="profile" />
          {/* </div> */}
          <div className="all-modules-greeting">Hey {profileName}!</div>
        </div>
        <button
          type="button"
          className="all-modules-logout-btn"
          aria-label="Logout"
          onClick={logoutHandler}
        >
          <span
            class="material-symbols-outlined"
            style={{ fontSize: "16px", color: "black" }}
          >
            logout
          </span>
        </button>
      </div>
      <div className="module-head hidden xl:block">all modules</div>
      <div className="top-module-nav">
        <div className="top-module-nav-title">modules</div>
        <div className="top-module-nav-row">
          {navCards.map((card) => {
            const activePath = card.path ? card.path.replace("..", "") : "";
            const isActive =
              !!activePath &&
              (location.pathname === activePath ||
                (activePath !== "/all" &&
                  location.pathname.startsWith(activePath)));

            return (
              <div
                key={card.title}
                className={`top-module-pill ${isActive ? "active" : ""}`}
                onClick={() => {
                  if (card.path) {
                    navigate(card.path);
                    dispatch(
                      authActions.setSelectedPage(card.path.replace("../", "")),
                    );
                  }

                  if (card.url) {
                    window.open(card.url, "_blank");
                  }
                }}
              >
                <img className="top-module-pill-icon" src={card.icon} alt="" />
                <div className="top-module-pill-text">{card.title}</div>
                {card.notifyCount && card.count > 0 && (
                  <div className="top-module-pill-notify">{card.count}</div>
                )}
                {card.redirect && (
                  <img
                    src={ArrowIcon}
                    className="top-module-pill-arrow"
                    alt=""
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className="module-tile-list">
        <ModuleTile
          bgImage={PeopleImg}
          bgIcon={PeopleIcon}
          title={"people"}
          subtitle={"Employee List, Reportees & Access"}
          path={"../people"}
          url={""}
        />

        {/* <ModuleTile
          bgImage={AssetImg}
          bgIcon={AssetIcon}
          title={"manage assets"}
          subtitle={"Manage IT Assets & Domain Access"}
          path={"../assets"}
          url={""}
        /> */}

        <ModuleTile
          bgImage={DocumentImg}
          bgIcon={DocumentIcon}
          title={"documents"}
          subtitle={"All Policies & Documents"}
          path={"../documents"}
          url={""}
        />

        {/* <ModuleTile
          bgImage={RecruitImg}
          bgIcon={RecruitIcon}
          title={"recruitment"}
          subtitle={"Job Listings, Candidates & Roles"}
          path={"../recruitment"}
          url={""}
        /> */}

        <ModuleTile
          bgImage={RequestImg}
          bgIcon={RequestIcon}
          title={"requests"}
          subtitle={"Initiate Change Requests and its Progress"}
          path={"../requests"}
          url={""}
        />

        <ModuleTile
          bgImage={SeperationImg}
          bgIcon={SeperationIcon}
          title={"separation"}
          subtitle={"Separation Flow & Tasks"}
          path={"../separation"}
          url={""}
        />

        <ModuleTile
          bgImage={AttendanceImg}
          bgIcon={AttendanceIcon}
          title={"attendance & leave"}
          subtitle={"Punch In & Regularize Attendance"}
          path={"../attendance"}
          url={""}
          // redirect={true}
        />
        {/* <ModuleTile
          bgImage={CompportImg}
          bgIcon={CompportIcon}
          title={"compport"}
          subtitle={"Compensation Management"}
          path={""}
          url={"https://moreretail.compport.com/"}
          redirect={true}
        /> */}
        {/* <ModuleTile
          bgImage={YourdostImg}
          bgIcon={YourdostIcon}
          title={"yourdost"}
          subtitle={"Quality of Life, Consult Psychologist & More"}
          path={""}
          url={"https://yourdost.com/userDashboard#/home"}
          redirect={true}
        /> */}
        <ModuleTile
          bgImage={MediImg}
          bgIcon={MediIcon}
          title={"medi assist"}
          subtitle={"Medical Insurance"}
          path={""}
          url={"https://portal.medibuddy.in/Home.aspx"}
          redirect={true}
        />
        <ModuleTile
          bgImage={HappayImg}
          bgIcon={HappayIcon}
          title={"happay"}
          subtitle={"Expense Management"}
          path={""}
          url={"https://expense.happay.in"}
          redirect={true}
        />
        <ModuleTile
          bgImage={QuestImg}
          bgIcon={QuestIcon}
          title={"quest2Travel"}
          subtitle={"Quest 2 travel"}
          path={""}
          url={"https://www.quest2travel.in/frontend/emplogin"}
          redirect={true}
        />
        <ModuleTile
          bgImage={ascentImg}
          bgIcon={ascentIcon}
          title={"stoHRM"}
          subtitle={"Payslips, Tax Computation & More"}
          path={""}
          url={"https://www.stohrm.com/stohrmwebapp/index.php/mrpl/admin"}
          redirect={true}
        />
        <ModuleTile
          bgImage={Helpdesk}
          bgIcon={helpdeskIcon}
          title={"helpdesk"}
          subtitle={"HR Helpdesk Support"}
          path={""}
          url={"https://sites.google.com/moreretail.in/hrhelpdesk/home"}
          redirect={true}
        />
        <ModuleTile
          bgImage={brandBay}
          bgIcon={brandBayIcon}
          title={"brandbay"}
          subtitle={"Communication, LinkedIn Assets & More"}
          path={""}
          url={"https://brandbay.more.in/"}
          redirect={true}
        />
        <ModuleTile
          bgImage={LearnMoreImg}
          bgIcon={LearnIcon}
          title={"learn"}
          subtitle={"Courses and Knowledge Checks"}
          path={""}
          url={"https://learn.more.in/"}
          redirect={true}
        />
      </div>
    </div>
  );
};
export default AllModules;
